import React from 'react'
import { Link } from 'react-router'
import sortBy from 'lodash/sortBy'
import DocumentTitle from 'react-document-title'
import access from 'safe-access'
import { config } from 'config'
import include from 'underscore.string/include'
import moment from 'moment';

const formatDate = (dateString) => {
  return moment(dateString, 'YYYY-MM-DD').format('MM DD YYYY');
};

class BlogIndex extends React.Component {
  render () {
    const pageLinks = []
    // Sort pages.
    const sortedPages = sortBy(this.props.route.pages, (page) =>
      access(page, 'data.date')
    ).reverse()
    sortedPages.forEach((page) => {
      if (access(page, 'file.ext') === 'html' && !include(page.path, '/404')) {
        const title = access(page, 'data.title') || page.path
        const imgSrc = access(page, 'data.featuredImage')
        const description = access(page, 'data.description')
        const date = access(page, 'data.date')
        pageLinks.push(
          <section className='article' key={page.path}>
            <div className='article-image'>
              <img src={imgSrc} />
            </div>
            <div className='article-text'>
              <h1>{title}</h1>
              <p className='date'>{formatDate(date)}</p>
              <p className='description'>{description}</p>
              <Link to={page.path}>Read more...</Link>
            </div>
          </section>
        )
      }
    })
    return (
      <DocumentTitle title={`${config.blogTitle} - A photographic diary of experimental precision cooking`}>
        <div>
          {pageLinks}
        </div>
      </DocumentTitle>
    )
  }
}

BlogIndex.propTypes = {
  route: React.PropTypes.object,
}

export default BlogIndex



/** WEBPACK FOOTER **
 ** ./index.js
 **/